import cookieControllerInstance from './cookieController';

export default class TestGroup {
  constructor(groupId = -1, code = null) {
    this.groupId = groupId;
    this.code = code;
    this.testId = null;
  }

  get letter() {
    return String.fromCharCode(64 + this.groupId);
  }

  get id() {
    return this.groupId;
  }

  get isActive() {
    return this.groupId === cookieControllerInstance.getABCookieById(this.testId);
  }

  _setTestId(id) {
    this.testId = id;
  }

  makeDefault(code = null) {
    this.groupId = 1;
    this.code = code;

    return this;
  }

  executeForGroup(groupId, fn, scope, args = []) {
    if (!(fn instanceof Function) || (this.groupId !== groupId && this.letter !== `${groupId}`.toUpperCase())) {
      return;
    }

    try {
      fn.call(scope, ...args);
    } catch (error) {
      console.error(error);
    }
  }

  executeDefault(scope, args = []) {
    if (!(this.code instanceof Function)) {
      return null;
    }

    try {
      return this.code.call(scope, ...args);
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}
